export default function Typography(fontFamily = `'Poppins', sans-serif`) {
  return {
    fontFamily,
    h6: {
      fontWeight: 500,
      fontSize: '0.75rem',
      letterSpacing: '0.05em',
      textTransform: 'uppercase'
    },
    h5: {
      fontSize: '0.875rem',
      fontWeight: 500,
      letterSpacing: '0.02em'
    },
    h4: {
      fontSize: '1rem',
      fontWeight: 500,
      letterSpacing: '0.01em'
    },
    h3: {
      fontSize: '1.25rem',
      fontWeight: 500,
      letterSpacing: '-0.01em'
    },
    h2: {
      fontSize: '1.5rem',
      fontWeight: 500,
      letterSpacing: '-0.02em'
    },
    h1: {
      fontSize: '2.125rem',
      fontWeight: 500,
      letterSpacing: '-0.02em'
    },
    subtitle1: {
      fontSize: '0.875rem',
      fontWeight: 500,
      letterSpacing: '0.01em'
    },
    subtitle2: {
      fontSize: '0.75rem',
      fontWeight: 400,
      letterSpacing: '0.02em'
    },
    caption: {
      fontSize: '0.75rem',
      fontWeight: 400,
      letterSpacing: '0.02em'
    },
    body1: {
      fontSize: '0.875rem',
      fontWeight: 400,
      lineHeight: '1.5em',
      letterSpacing: '0.01em'
    },
    body2: {
      fontSize: '0.875rem',
      fontWeight: 400,
      lineHeight: '1.43em',
      letterSpacing: '0.01em'
    },
    button: {
      textTransform: 'none',
      fontWeight: 500,
      letterSpacing: '0.02em'
    },
    commonAvatar: {
      cursor: 'pointer',
      borderRadius: '8px'
    },
    smallAvatar: {
      width: '22px',
      height: '22px',
      fontSize: '1rem'
    },
    mediumAvatar: {
      width: '34px',
      height: '34px',
      fontSize: '1.2rem'
    },
    largeAvatar: {
      width: '44px',
      height: '44px',
      fontSize: '1.5rem'
    }
  };
}
